// Данный файл - лишь собрание подключений готовых компонентов.
// Рекомендуется создавать отдельный файл в папке components и подключать все там

import "./functions/index-page-tabs";

// Подключение свайпера
import Swiper, {EffectFade, Navigation, Pagination, Thumbs} from "swiper";

Swiper.use([Navigation, Pagination, EffectFade, Thumbs]);
window.Swiper = Swiper;

const complexSlider = new Swiper(".complex-slider", {
    slidesPerView: 1,
    touchRatio: 0.2,
    spaceBetween: 10,
    navigation: {
        nextEl: ".complex-slider__next.swiper-button-next",
        prevEl: ".complex-slider__prev.swiper-button-prev",
    },
    pagination: {
        el: ".complex-slider__pagination.swiper-pagination",
        type: "bullets",
        clickable: true,
    },
});

const complexCardThumbs = document.querySelectorAll(".complex-card-thumbs");
const complexCardSliders = document.querySelectorAll(".complex-card-slider");

if (complexCardThumbs.length)
    complexCardThumbs.forEach((thumb, index) => {
        const thumbSlider = new Swiper(thumb, {
            speed: 1000,
            touchRatio: 0.2,
            slideToClickedSlide: true,
            nested: true,
            watchSlidesProgress: true,
            breakpoints: {
                767: {
                    slidesPerView: 1.5,
                    spaceBetween: 16,
                },
                991: {
                    spaceBetween: 16,
                    slidesPerView: 2,
                },
                1260: {
                    spaceBetween: 16,
                    slidesPerView: 3,
                },
            },
        });
        const prevBtn = thumb.parentNode.querySelector(
            ".complex-card-thumbs__prev.swiper-button-prev"
        );
        const nextBtn = thumb.parentNode.querySelector(
            ".complex-card-thumbs__next.swiper-button-next"
        );

        new Swiper(complexCardSliders[index], {
            speed: 1000,
            spaceBetween: 10,
            nested: true,
            watchSlidesProgress: true,
            thumbs: {
                swiper: thumbSlider,
            },
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
        });
    });

const cardSliders = document.querySelectorAll(".card-slider");
if (cardSliders.length) {
    cardSliders.forEach((slider, index) => {
        const pagination = slider.parentElement.querySelector(
            ".card-slider__pagination.swiper-pagination"
        );
        const btnPrev = slider.querySelector(".card-slider__prev");
        const btnNext = slider.querySelector(".card-slider__next");
        new Swiper(slider, {
            slidesPerView: 1,
            speed: 1000,
            effect: "fade",
            nested: true,
            pagination: {
                el: pagination,
                type: "bullets",
                clickable: true,
            },
            navigation: {
                nextEl: btnNext,
                prevEl: btnPrev,
            },
        });
    });
}
new Swiper(".reviews-slider", {
    breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 24,
        },
        576: {
            slidesPerView: 1.5,
            spaceBetween: 24,
        },
        767: {
            slidesPerView: 2,
            spaceBetween: 24,
        },
        991: {
            slidesPerView: 2.9,
            spaceBetween: 24,
        },
        1100: {
            slidesPerView: 3,
            spaceBetween: 32,
        },
        1400: {
            slidesPerView: 3,
            spaceBetween: 32,
        },
    },
    navigation: {
        nextEl: ".reviews-slider__next.swiper-button-next",
        prevEl: ".reviews-slider__prev.swiper-button-prev",
    },
    pagination: {
        el: ".reviews-slider__pagination.swiper-pagination",
        type: "bullets",
        clickable: true,
    },
});

new Swiper(".take-slider", {
    breakpoints: {
        320: {
            slidesPerView: 1.6,
            spaceBetween: 16,
        },
        500: {
            slidesPerView: 2.5,
            spaceBetween: 16,
        },
        767: {
            slidesPerView: 3.5,
            spaceBetween: 16,
        },
        991: {
            slidesPerView: 4,
        },
    },
});

new Swiper(".channel-slider", {
    breakpoints: {
        320: {
            slidesPerView: 3,
            spaceBetween: 24,
        },
        576: {
            slidesPerView: 2,
            spaceBetween: 24,
        },
        767: {
            slidesPerView: 2.1,
            spaceBetween: 24,
        },
        991: {
            slidesPerView: 2.2,
            spaceBetween: 24,
        },
        1200: {
            slidesPerView: 2.4,
            spaceBetween: 32,
        },
    },
    navigation: {
        nextEl: ".channel-slider__next.swiper-button-next",
        prevEl: ".channel-slider__prev.swiper-button-prev",
    },
});
new Swiper(".placement-slider", {
    slidesPerView: 1,
    spaceBetween: 24,
    navigation: {
        nextEl: ".placement-slider__next.swiper-button-next",
        prevEl: ".placement-slider__prev.swiper-button-prev",
    },
    pagination: {
        el: ".placement-slider__pagination.swiper-pagination",
        type: "bullets",
        clickable: true,
    },
});

const apartmentBottomSlider = new Swiper(".apartment-sliders .slider-bottom", {
    speed: 1000,
    touchRatio: 0.2,
    slideToClickedSlide: true,
    nested: true,
    watchSlidesProgress: true,
    breakpoints: {
        767: {
            slidesPerView: 1.5,
            spaceBetween: 16,
        },
        991: {
            spaceBetween: 16,
            slidesPerView: 2,
        },
        1260: {
            spaceBetween: 16,
            slidesPerView: 3,
        },
    },
});

const apartmentTopSlider = new Swiper(".apartment-sliders .slider-top", {
    speed: 1000,
    spaceBetween: 10,
    watchSlidesProgress: true,
    thumbs: {
        swiper: apartmentBottomSlider,
    },
    navigation: {
        nextEl: ".slider-top__next.swiper-button-next",
        prevEl: ".slider-top__prev.swiper-button-prev",
    },
});

// import { Chart, registerables } from "chart.js";
// Chart.register(...registerables);
// new Chart(document.getElementById("line-chart"), {
//     type: "line",
//     data: {
//         labels: [
//             "Январь",
//             "Февраль",
//             "Март",
//             "Апрель",
//             "Май",
//             "Июнь",
//             "Июль",
//             "Август",
//             "Сентябрь",
//             "Октябрь",
//             "Ноябрь",
//             "Декабрь",
//         ],

//         datasets: [
//             {
//                 data: [
//                     94000, 60000, 0, 15000, 13000, 56323, 0, 28000, 60000,
//                     78000, 20000, 10000,
//                 ],
//                 label: "line",
//                 borderColor: "#3B82F6",
//                 fill: false,
//                 tension: 0.3,
//             },
//         ],
//     },
//     options: {
//         legend: {
//             display: false,
//         },
//     },
// });

import {Fancybox} from "@fancyapps/ui";

Fancybox.bind("[data-fancybox]", {});

// import leaflet from "leaflet";
// const L = leaflet;
// var map = L.map("map").setView([51.505, -0.09], 13);

// // Добавление слоя карты (OpenStreetMap)
// L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
//     maxZoom: 18,
// }).addTo(map);

// // Добавление маркера
// var marker = L.marker([51.5, -0.09]).addTo(map);

// // Добавление обработчика события "click" на маркер
// marker.on("click", function () {
//     // Отображение блока с информацией
//     var card = document.querySelector(".card");
//     card.style.display = "block";
// });
// var markers = [
//     { latlng: [51.5, -0.09], title: "Marker 1" },
//     { latlng: [51.505, -0.08], title: "Marker 2" },
//     { latlng: [51.51, -0.1], title: "Marker 3" },
// ];

// markers.forEach(function (marker) {
//     var m = L.marker(marker.latlng).addTo(map);
//     m.bindPopup(marker.title);
// });

import SmoothScroll from "smooth-scroll";

new SmoothScroll(".hero-form__header-right.--mobile", {
    speed: 1000,
    speedAsDuration: true,
    offset: 100,
});

new SmoothScroll(".smooth-scroll", {
    speed: 1000,
    speedAsDuration: true,
    offset: 100,
});
const articleTabsButtons =
    document.querySelectorAll('[data-article_tab_button]');
if (articleTabsButtons.length) {
    articleTabsButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            articleTabsButtons.forEach(function (elem) {
                elem.classList.remove('--active')
            });
            button.classList.add('--active');
            let groupId = button.getAttribute('data-group_id');
            console.log(groupId);
            if (groupId) {
                let articles = document.querySelectorAll('article[data-group_id]');
                if (articles.length) {
                    articles.forEach(function (article) {
                        if (groupId === 'all')
                            article.style.display = "block";
                        else {
                            if (article.getAttribute('data-group_id') === groupId)
                                article.style.display = "block";
                            else
                                article.style.display = "none";
                        }
                    });
                }
            }


        });
    });
}


const QAbuttons = document.querySelectorAll('button[data-qa_group_id]');
const QAquestions = document.querySelectorAll('div[data-qa_group_id]');
if(QAbuttons.length){
    QAbuttons.forEach(function (button){
        button.addEventListener('click', function (e){
            e.preventDefault();
            let groupId = parseInt(button.getAttribute('data-qa_group_id'));
            QAbuttons.forEach(function (b){
                b.classList.remove('--active');
            })
            button.classList.add('--active');
            if(QAquestions.length){
                QAquestions.forEach(function (qa){
                    if(parseInt(groupId) === 0)
                        qa.style.display = 'block';
                    else{
                        if(parseInt(qa.getAttribute('data-qa_group_id')) === groupId)
                            qa.style.display = 'block';
                        else
                            qa.style.display = 'none';
                    }
                })
            }


        });



    })
}
